import React from 'react';
import { CheckCircle2, FileText, Users, Lightbulb, Calendar } from 'lucide-react';
export function ProductSection() {
  return <section className="py-20 bg-white" data-id="element-148">
      <div className="container mx-auto px-4" data-id="element-149">
        <div className="flex flex-col lg:flex-row items-center gap-16 max-w-6xl mx-auto" data-id="element-150">
          <div className="flex-1 order-2 lg:order-1" data-id="element-151">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-152">
              ¿Qué es DERECHO 360?
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-153">
              DERECHO 360 es un pack completo de clases de Derecho para nivel
              secundario, listo para usar, diseñado para docentes argentinos que
              quieren enseñar con claridad, seguridad y sin improvisar.
            </p>

            <div className="space-y-6" data-id="element-154">
              <div className="flex items-start gap-4" data-id="element-155">
                <div className="bg-amber-50 p-2 rounded-lg shadow-sm border border-amber-100" data-id="element-156">
                  <FileText className="h-6 w-6 text-blue-900" data-id="element-157" />
                </div>
                <div data-id="element-158">
                  <h4 className="font-bold text-slate-900" data-id="element-159">
                    Clases explicadas paso a paso
                  </h4>
                  <p className="text-slate-600 text-sm" data-id="element-160">
                    Todo el contenido desarrollado para que solo tengas que leer
                    y explicar.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-161">
                <div className="bg-amber-50 p-2 rounded-lg shadow-sm border border-amber-100" data-id="element-162">
                  <Users className="h-6 w-6 text-blue-900" data-id="element-163" />
                </div>
                <div data-id="element-164">
                  <h4 className="font-bold text-slate-900" data-id="element-165">
                    Actividades pensadas para adolescentes
                  </h4>
                  <p className="text-slate-600 text-sm" data-id="element-166">
                    Dinámicas que enganchan, generan debate y participación
                    real.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-167">
                <div className="bg-amber-50 p-2 rounded-lg shadow-sm border border-amber-100" data-id="element-168">
                  <Lightbulb className="h-6 w-6 text-blue-900" data-id="element-169" />
                </div>
                <div data-id="element-170">
                  <h4 className="font-bold text-slate-900" data-id="element-171">
                    Ejemplos reales y actuales
                  </h4>
                  <p className="text-slate-600 text-sm" data-id="element-172">
                    Casos que conectan con la realidad argentina de hoy.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-173">
                <div className="bg-amber-50 p-2 rounded-lg shadow-sm border border-amber-100" data-id="element-174">
                  <Calendar className="h-6 w-6 text-blue-900" data-id="element-175" />
                </div>
                <div data-id="element-176">
                  <h4 className="font-bold text-slate-900" data-id="element-177">
                    Organización por ciclo lectivo
                  </h4>
                  <p className="text-slate-600 text-sm" data-id="element-178">
                    Una progresión lógica para todo el año escolar.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 p-6 bg-amber-50 border-l-4 border-blue-900 rounded-r-lg" data-id="element-179">
              <p className="font-medium text-blue-900" data-id="element-180">
                "DERECHO 360 es como un GPS didáctico. No improvisás rutas.
                Sabés exactamente por dónde ir."
              </p>
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2" data-id="element-181">
            <div className="relative" data-id="element-182">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-900 to-amber-500 rounded-full blur-[100px] opacity-20" data-id="element-183"></div>
              <img src="https://cdn.magicpatterns.com/uploads/tMZG5rVVPzna4TQY49K55p/mockup_principal_derecho_360.png" alt="Derecho 360 Producto" className="relative z-10 w-full transform transition-transform hover:scale-105 duration-500" data-id="element-184" />
            </div>
          </div>
        </div>

        <div className="mt-24 max-w-4xl mx-auto text-center" data-id="element-185">
          <h3 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-186">
            ¿Para quién es DERECHO 360?
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-187">
            <div className="bg-amber-50 p-6 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-188">
              <h4 className="font-bold text-lg mb-4 flex items-center justify-center gap-2" data-id="element-189">
                <CheckCircle2 className="text-green-500" data-id="element-190" /> Es para vos si:
              </h4>
              <ul className="space-y-3 text-left text-slate-600" data-id="element-191">
                <li className="flex items-center gap-2" data-id="element-192">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-193" /> Das
                  Derecho en secundaria
                </li>
                <li className="flex items-center gap-2" data-id="element-194">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-195" /> Manejás
                  varios cursos
                </li>
                <li className="flex items-center gap-2" data-id="element-196">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-197" /> Tenés poco
                  tiempo para planificar
                </li>
                <li className="flex items-center gap-2" data-id="element-198">
                  <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-199" /> Estás
                  cansado de improvisar
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-slate-300 opacity-75" data-id="element-200">
              <h4 className="font-bold text-lg mb-4 text-slate-500" data-id="element-201">
                No es para vos si:
              </h4>
              <p className="text-slate-600" data-id="element-202">
                Disfrutás preparar todo desde cero siempre, tenés tiempo libre
                de sobra y te gusta armar planificaciones los fines de semana.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}